module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gebb/Desktop/live/~/babel-runtime/core-js/get-iterator.js
// module id = 73
// module chunks = 0